import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#how", label: "How it works" },
  { href: "#plans", label: "Plans" },
  { href: "#partners", label: "Partners" },
  { href: "#faqs", label: "FAQs" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/60 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          aria-label="Zyp home"
          className="flex items-center gap-2 group"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <span className="h-8 w-8 rounded-lg bg-[#FF5A00] flex items-center justify-center font-heading font-bold text-white text-lg shadow-[0_0_30px_-5px_#FF5A00]">
            Z
          </span>
          <span className="font-heading text-xl tracking-tight font-semibold">Zyp</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => scrollTo(l.href)}
              className="text-sm text-zinc-400 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            data-testid="nav-cta-early-access"
            onClick={() => scrollTo("#waitlist")}
            className="bg-[#FF5A00] hover:bg-[#FF7A33] text-white rounded-full px-6 h-11 font-medium"
          >
            Get early access
          </Button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/5 bg-black/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.href}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                onClick={() => scrollTo(l.href)}
                className="text-left text-zinc-300 hover:text-white py-2"
              >
                {l.label}
              </button>
            ))}
            <Button
              data-testid="nav-mobile-cta"
              onClick={() => scrollTo("#waitlist")}
              className="bg-[#FF5A00] hover:bg-[#FF7A33] text-white rounded-full h-11 mt-2"
            >
              Get early access
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
